export default __webpack_public_path__ + "static/media/5020.6016b0a3.png";